export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11510.9b4e2be1.jpg";